import { render, staticRenderFns } from "./LocalityForm.vue?vue&type=template&id=3f50a6e7&scoped=true&"
import script from "./LocalityForm.vue?vue&type=script&lang=js&"
export * from "./LocalityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50a6e7",
  null
  
)

export default component.exports